// Yeni Banka Hesabı Ekle / Banka Hesabı Düzenle penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.addBankAccount';

export const addBankAccountGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Banka hesabı nasıl eklenir?'),
  intro: t(`${G}.intro`, 'Bu pencere yeni bir ana banka hesabı açar veya mevcut hesabın bilgilerini düzenler. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Yeni / Düzenle'),
    body: t(`${G}.regions.body`, 'Hesap bilgileri'),
    footer: t(`${G}.regions.footer`, 'Kaydet'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Ekleme mi, düzenleme mi?'),
      text: t(`${G}.s1.text`, '"Yeni Banka Hesabı" düğmesiyle açtıysanız başlık "Yeni Banka Hesabı Ekle", satırın ⋮ menüsündeki Düzenle ile açtıysanız "Banka Hesabı Düzenle" olur ve form mevcut bilgilerle dolu gelir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Zorunlu alanlar'),
      text: t(`${G}.s2.text`, 'Banka Adı ve Hesap Numarası zorunludur. Hesap numarası yalnız rakamlardan oluşmalı ve en az 5 haneli olmalıdır. Banka Şube Adı (bankanın kendi şubesi) isteğe bağlıdır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. IBAN ve para birimi'),
      text: t(`${G}.s3.text`, 'IBAN isteğe bağlıdır; yazarken başına TR kendiliğinden eklenir ve dörderli gruplanır. Girerseniz TR ile başlayan 26 karakter olmalıdır. Para Birimi listesinde TRY ile şirket ayarlarında açık olan dövizler bulunur.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Şirket şubesi ve banka yetkilisi'),
      text: t(`${G}.s4.text`, 'Şirket Şubesi, hesabın işletmenizin hangi şubesine ait olduğunu belirtir (isteğe bağlı). Şube yöneticileri Banka sayfasında yalnız kendi şubelerine bağlı hesapları görür. Banka Yetkilisi ve Yetkili Telefon, bankadaki iletişim kişiniz içindir (isteğe bağlı).'),
      tips: [
        t(`${G}.s4.tip1`, 'Şube yöneticisi olarak hesap açarsanız şube alanı kendi şubenize kilitlidir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Hesap türü: POS ve Çek'),
      text: t(`${G}.s5.text`, 'POS Hesabı anahtarını açarsanız hesap, satış ekranlarının ödeme ayarlarında POS ödeme seçeneğine bağlanabilir hale gelir. Çek Hesabı anahtarını açarsanız hesabın ⋮ menüsünde Çek Defterleri görünür. İkisi birlikte de açılabilir.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Kaydedin'),
      text: t(`${G}.s6.text`, '"Kaydet" (düzenlemede "Güncelle") zorunlu alanlar dolunca açılır. Yeni hesap 0 bakiyeyle açılır; mevcut parayı girmek için hesabın "İşlem Yap" düğmesinden Para Yatırma kullanın.'),
    },
  ],
});
